export type TelegramIdentity = {
  id: string
  username: string | null
  displayName: string | null
  avatarUrl: string | null
}

export type User = {
  id: string
  email: string | null
  displayName: string
  telegram: TelegramIdentity | null
  role: string
  locale: string
  emailVerified: boolean
  workspaceOwnerId?: string
  isMember?: boolean
  accessStatus?: 'pending' | 'approved' | 'rejected'
  canReviewAccess?: boolean
}

export type Session = { id: string; ip?: string; user_agent?: string; created_at: string; revoked_at?: string }
export type AuthState = { user: User; csrfToken: string; sessions: Session[] }

export function userLabel(user: User) {
  return user.displayName || user.telegram?.displayName || user.telegram?.username || user.email || 'Telegram user'
}
